module.exports = __webpack_public_path__ + "img/privacy.2148a0b6.jpg";